import { useQuery } from '@tanstack/react-query'
import { auditApi } from '../api/client'
import './AgentHealth24h.css'

export function AgentHealth24h() {
  const q = useQuery({ queryKey: ['agent-health-24h'],
    queryFn: auditApi.agentHealth, refetchInterval: 30000 })
  const agents = q.data?.agents ?? []
  return (
    <div className="card agent-health-24h">
      <h3>Agent health · 24h</h3>
      {q.isLoading && <p className="ah-muted">Loading…</p>}
      {q.isError && <p className="ah-muted">Failed to load agent health.</p>}
      {!q.isLoading && !q.isError && agents.length === 0 && (
        <p className="ah-empty">No decisions in the last 24h.</p>
      )}
      {agents.length > 0 && (
        <table className="ah-table">
          <thead>
            <tr><th>Agent</th><th>Decisions</th><th>Avg conf</th><th>Last</th></tr>
          </thead>
          <tbody>
            {agents.map((a) => (
              <tr key={a.agent_name}>
                <td>{a.agent_name}</td>
                <td>{a.decisions}</td>
                <td>{a.avg_confidence.toFixed(2)}</td>
                <td>{a.last_decision_at
                      ? a.last_decision_at.replace('T', ' ').slice(0, 19) + ' UTC'
                      : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
